import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Container } from "react-bootstrap";
import Exchangetable from "../Component/Exchangetable";
import { useParams } from "react-router-dom";
import { getExchanges } from "../Actions/v1/user";

function Exchanges() {
  const params = useParams();
  const [exchangelist, setExchangeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [searchtext, setSearchtext] = useState("");

  const getExchangelist = async (data) => {
    let resp = await getExchanges({
      page: currentPage,
      limit,
      exchangetype: params?.type,
      type : params?.extype,
      searchtext,
    });
    console.log("🚀 ~ getExchangelist ~ resp:", resp);
    if(resp?.status){
      if (data == "page" && currentPage > 0) {
        setExchangeList([...exchangelist, resp.data]);
      } else {
        setExchangeList(resp.data);
      }
    }
  };


  useEffect(() => {
    if (params?.type) {
      getExchangelist();
    }
  }, [params?.type, searchtext]);

  useEffect(() => {
    if (currentPage > 0) {
      getExchangelist("page");
    }
  }, [currentPage]);

  return (
    <div>
      <Header />
      <div className="inner_page">
        <img src={Images.elogo} className="elogo" alt="elogo" />
        <Container className="mt-4">
          <h5 className="d_white">{params?.type == "CEX" ? "Centralized" : "Decentralized"} Exchanges</h5>
          <p className="mt-3 d_white">
            Eda Face Listing Platforms ranks the top {params?.type == "CEX" ? "Centralized" : "Decentralized"} exchanges
            based on trading volumes, market share of DeFi markets.
          </p>

          <Exchangetable
            type={params?.type}
            data={exchangelist}
            itemsPerPage={6}
            currentPage={currentPage}
            setCurrentPage={(data) => setCurrentPage(data)}
            searchtext={searchtext}
            setSearchtext={(data) => setSearchtext(data)}
          />
        </Container>
      </div>

      <Footer />
    </div>
  );
}

export default Exchanges;
